"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var React = _interopRequireWildcard(require("react"));

var _Ellipsis = _interopRequireDefault(require("@bedrock/icons-svg/lib/asn/Ellipsis"));

var _RockIcon = _interopRequireDefault(require("../components/RockIcon"));

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var Ellipsis = function Ellipsis(props, ref) {
  return /*#__PURE__*/React.createElement(_RockIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _Ellipsis.default
  }));
};

Ellipsis.displayName = 'Ellipsis';

var _default = /*#__PURE__*/React.forwardRef(Ellipsis);

exports.default = _default;